import React from "react";

const statusConfig = {
    TRIALING: {label: 'Prova gratuita', className: 'bg-info'},
    ACTIVE: {label: 'Attivo', className: 'bg-success'},
    BASIC_ACTIVE: {label: 'Basic', className: 'bg-secondary'},
    CANCEL_AT_PERIOD_END: {label: 'In scadenza', className: 'bg-warning text-dark'},
    PAYMENT_PENDING: {label: 'Pagamento in attesa', style: {backgroundColor: '#fd7e14'}},
    PAYMENT_FAILED: {label: 'Pagamento fallito', className: 'bg-danger'},
    SUSPENDED: {label: 'Sospeso', className: 'bg-danger'},
    EXPIRED: {label: 'Scaduto', style: {backgroundColor: '#495057'}},
    CANCELED: {label: 'Cancellato', style: {backgroundColor: '#495057'}},
};

const SubscriptionStatusBadge = ({status}) => {
    const config = statusConfig[status] || {label: status, className: 'bg-secondary'};

    return (
        <span
            className={`badge rounded-pill px-3 py-2 ${config.className || ''} text-white`}
            style={config.style || {}}
        >
            {config.label}
        </span>
    );
};

export default SubscriptionStatusBadge;
